import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { installAnalytics } from "./analytics";
import { AppRoutes } from "./routes";

function getBasename() {
  const base = import.meta.env.BASE_URL || "/";
  return base === "/" ? "/" : base.replace(/\/$/, "");
}

export function App() {
  useEffect(() => {
    installAnalytics();
  }, []);

  return (
    <BrowserRouter basename={getBasename()}>
      <AppRoutes />
    </BrowserRouter>
  );
}
